import { Navigate, Outlet } from "react-router-dom";
import { useAtom } from "jotai";
import { authenticationAtom } from './State';

export default function Protected() {
  const [authentication] = useAtom(authenticationAtom);

  return authentication ? <Outlet /> : <Navigate to="/login" />;
};